<template>
  <MyModal
    title="风场方案对比"
    v-if="isShowTable"
    width="670px"
    height="auto"
    :style="{ left: '25%', top: '25%', fontWeight: '500', zIndex: 2000 }"
    @closeClick="handleCloseModalClick()"
  >
    <div class="solid-table">
      <el-table :data="tableData"
        row-class-name="table-row-class-name"
        :header-row-style="{
          background: 'transparent',
        }"
        max-height="500">
        <el-table-column
          v-for="col in columns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :type="col.type"
          :fixed="col.fixed"
          :min-width="col.minWidth"
        >
        </el-table-column>
      </el-table>
    </div>
  </MyModal>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import MyModal from '././modal';

const COLUMNS = [
  {
    unit: 'MW',
    name: '容量(MW)',
    value: 'capacity'
  },
  {
    unit: '',
    name: '机型',
    value: 'turbineType'
  },
  {
    unit: '台',
    name: '台数(台)',
    value: 'count'
  },
  {
    unit: 'm',
    name: '轮毂高度(m)',
    value: 'hubHeight'
  },
  {
    unit: 'MWH',
    name: '年发电量(MWH)',
    value: 'annualEnergy'
  },
  {
    unit: 'h',
    name: '满发小时数(h)',
    value: 'fullLoadHour'
  },
  // {
  //   unit: 'km',
  //   name: '道路长度(km)',
  //   value: 'roadLength'
  // },
  // {
  //   unit: '万元',
  //   name: '道路造价(万元)',
  //   value: 'roadInvest'
  // },
  // {
  //   unit: 'km',
  //   name: '线路长度(km)',
  //   value: 'wireLength'
  // },
  // {
  //   unit: '万元',
  //   name: '线路造价(万元)',
  //   value: 'wireInvest'
  // },
  {
    unit: '%',
    name: 'IRR(项目税前)(%)',
    value: 'roiBefore'
  },
  {
    unit: '%',
    name: 'IRR(项目税后)(%)',
    value: 'roi'
  },
  {
    unit: '%',
    name: 'IRR(资本金)(%)',
    value: 'cfopcIrr'
  },
  {
    unit: '元/kWh',
    name: 'LCOE(元/kWh)',
    value: 'lcoe'
  }
];
export default {
  components: { MyModal },
  props: {
    planTableData: Array,
    tableOptimalIndex: Number,
    height: Number,
    isShowContrast: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isShowTable: false
    };
  },
  computed: {
    columns() {
      if (isEmpty(this.tableData)) return [];
      const cols = [
        {
          label: '对比项',
          prop: 'name',
          fixed: true,
          minWidth: 120
        }
      ];
      this.planTableData.forEach((eco, i) => {
        cols.push({
          label: eco.planName,
          prop: 'value' + i,
          minWidth: 120
        });
      });
      return cols;
    },
    tableData() {
      if (isEmpty(this.planTableData)) return [];
      return COLUMNS.map(col => {
        const row = {
          ...col
        };
        this.planTableData.forEach((eco, i) => {
          row[`value${i}`] = eco[col.value];
        });
        return row;
      });
    }
  },
  watch: {
    planTableData: {
      handler(val) {
        console.log(val);
        if (val) {
          this.isShowTable = true;
        } else {
          this.isShowTable = false;
        }
      }
    },
    isShowContrast: {
      handler(val) {
        this.isShowTable = val;
      }
    }
  },
  methods: {
    handleCloseModalClick() {
      this.$emit('closeClick');
    },
    setRowStyle({ columnIndex }) {
      if (this.planTableData.length > 1) {
        if (columnIndex === this.tableOptimalIndex + 1) {
          return 'color: #537dfc;font-size: 13px;font-weight: 600;';
        }
      }
    }
  }
};
</script>
